import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteModifier } from 'api/Admin/Modifiers';

import { showAlert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const ButtonActions = ({ selectedRows, setSelectedRows }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const customLabelText = () => {
    return selectedRows.length > 1 ? 'modifiers' : 'modifier';
  };

  const deletionMutation = useMutation({
    mutationFn: (data) => {
      return deleteModifier(navigate, { data });
    },
    onSuccess: async (data) => {
      if (data.code === 0) {
        showAlert({ title: `${customLabelText()} deleted successfully`, color: 'success' });
        setShowConfirmation(false);
        setSelectedRows([]);
        await queryClient.invalidateQueries(['modifiers']);
      } else {
        showAlert({
          title: data?.error ?? 'Something went wrong deleting modifiers',
          color: 'danger'
        });
      }
    }
  });

  const confirmDeletion = async () => {
    const derivedIds = selectedRows.map((row) => row?.data?.code);
    await deletionMutation.mutateAsync(derivedIds);
  };

  return (
    <>
      <Button
        text="Delete"
        color="danger"
        onClick={() => {
          setShowConfirmation(true);
        }}
      />
      <Confirm
        loading={deletionMutation?.isLoading}
        disabled={deletionMutation?.isLoading}
        isOpen={showConfirmation}
        handleOpen={showConfirmation}
        handleClose={() => setShowConfirmation(false)}
        handleContinue={() => {
          confirmDeletion();
        }}
        title={`Delete ${customLabelText()}`}
        message={`Are you sure you want to delete the selected ${customLabelText()}?`}
        primaryBtnTxt={`Delete ${customLabelText()}`}
        secondaryBtnTxt="Close"
        icon="trash-mono"
        variant="danger"
      />
    </>
  );
};

export default ButtonActions;
